const colors = {
    primary_background_dark : '#3F4653',
    toolbar_color_dark : '#252833'
};

export default colors;